import { render } from "./BalCard.vue?vue&type=template&id=3be62dbc&scoped=true&ts=true"
import script from "./BalCard.vue?vue&type=script&lang=ts"
export * from "./BalCard.vue?vue&type=script&lang=ts"

import "./BalCard.vue?vue&type=style&index=0&id=3be62dbc&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3be62dbc"]])

export default __exports__